import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext'; // Ajusta la ruta según tu estructura
import { URLserver } from './urlServer';

// URL base de tu API
const API_URL = 'http://localhost:8000/api/';

// Configuración de axios
const apiClient = axios.create({
    baseURL: URLserver,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Función para configurar interceptores
export const setupInterceptors = (logoutUser) => {
    // Interceptor para agregar el token en cada solicitud
    apiClient.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).token : null;

            // Si hay un token, lo agrega a la cabecera Authorization
            if (token) {
                config.headers['Authorization'] = `Token ${token}`;
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Interceptor para manejar respuestas
    apiClient.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            const { response } = error;
            if (response) {
                const { status } = response;

                // Si el token es inválido (por ejemplo, 401 Unauthorized), desloguear al usuario
                if (status === 401) {
                    logoutUser(); // Llama a la función de cierre de sesión
                }
            }

            return Promise.reject(error);
        }
    );
};

// Funciones para realizar solicitudes a la API
export const apiService = {
    login: async (username, password) => {
        return await apiClient.post('login', { username, password });
    },
    logout: async () => {
        return await apiClient.post('logout');
    },
    fetchData: async (endpoint) => {
        return await apiClient.get(endpoint);
    },
    postData: async (endpoint, data) => {
        return await apiClient.post(endpoint, data);
    },

    deleteData: async (endpoint) => {
        return await apiClient.delete(endpoint);
    },
    // Puedes agregar más funciones para otras rutas de la API
};
